import axios, { AxiosResponse } from 'axios';
import envConfig from '../config/environment-config';
import { localStorageMethods } from '../pages/portal-pharmaceutical/common/helpers';
import { IPharmaceuticalCrendentials, LocalStorageKeysEnum } from '../pages/portal-pharmaceutical/common/contracts';

export function createHeaders() {
  const credentials =
    localStorageMethods.getItem<IPharmaceuticalCrendentials>(
      LocalStorageKeysEnum.PHARMACEUTICAL_CREDENTIALS,
    );

  if (!credentials?.access_token) {
    return {
      headers: {
        'Content-Type': 'application/json',
      },
    };
  }

  return {
    headers: {
      Authorization: `Bearer ${credentials.access_token}`,
      'Content-Type': 'application/json',
    },
  };
}

export async function authenticatedPostRequest(
  method: string,
  body?: any,
): Promise<AxiosResponse<any, any>> {
  const url = `${envConfig.pharmaceuticalPortalApiUrl}/${method}`;
  const headers = createHeaders();
  const res = await axios.post(url, body, headers);
  if (res.status === 401) {
    if (localStorageMethods.getItem(LocalStorageKeysEnum.PHARMACEUTICAL_CREDENTIALS)) {
      localStorageMethods.removeItem(LocalStorageKeysEnum.PHARMACEUTICAL_CREDENTIALS);
      window.location.reload();
    }
  }
  return res;
}

export async function authenticatedGetRequest(
  method: string,
  params?: any,
  queryParams?: any,
): Promise<AxiosResponse<any, any>> {
  const url = `${envConfig.pharmaceuticalPortalApiUrl}/${method}${params ?? ''}`;
  const headers = createHeaders();
  const res = await axios.get(url, {
    ...headers,
    params: queryParams,
  });
  if (res.status === 401) {
    if (localStorageMethods.getItem(LocalStorageKeysEnum.PHARMACEUTICAL_CREDENTIALS)) {
      localStorageMethods.removeItem(LocalStorageKeysEnum.PHARMACEUTICAL_CREDENTIALS);
      window.location.reload();
    }
  }
  return res;
}
